import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import CartButton from 'components/cart/button';
import Login from 'components/header/login';
import Search from 'components/search';
import Address from 'components/header/address';
import HeaderNav from 'components/header/nav';
import Banner from 'components/banner';
import AsyncAvailabilityModal from 'components/availability/async';
import NavWrapper from 'components/header/NavWrapper';
import AppHeader from 'components/header/AppHeader';
import { logoContainer } from 'components/header/navWrapper.mod.scss';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import { inlineBlock, hidden, tablet_block } from 'scy/display.mod.scss';
import headerStyles from 'components/header/styles.mod.scss';
import styles from './styles.mod.scss';

export default function TipAndRateHeader({
  cartOpen,
  isScrollingDown,
  headerRef,
  toggleRef,
  onClick
}) {
  return (
    <div
      className={classnames(headerStyles.container, styles.header)}
      onClick={onClick}
    >
      <AppHeader
        cartOpen={cartOpen}
        isScrollingDown={isScrollingDown}
        headerRef={headerRef}
      >
        <NavWrapper className={headerStyles.navWrapper} toggleRef={toggleRef}>
          <Link to="/" className={classnames(logoContainer, inlineBlock)}>
            <WordmarkIcon />
          </Link>
          <HeaderNav />
          <Login />
        </NavWrapper>

        <div className={headerStyles.searchBarContainer}>
          <Search className={classnames(hidden, tablet_block)} />
          <Address
            trackingParams={{ source: 'Header' }}
            className={styles.addressContainer}
          />
          <div
            className={classnames(
              headerStyles.cartButtonContainer,
              styles.cartButtonContainer
            )}
          >
            <CartButton className={headerStyles.cartButton} />
          </div>
        </div>

        <Banner className={classnames(hidden, tablet_block)} />

        <AsyncAvailabilityModal />
      </AppHeader>
    </div>
  );
}
